const variables = {
  fullStarColor: '#C8102E',
  emptyStarColor: '#ffffff',
  strokeColor: '#C8102E',
  shareCartSenderNameLength: 71,
};

export default variables;



// WEBPACK FOOTER //
// ./src/brawny/variables.js